import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusBannerComponent } from './status-banner/status-banner.component';
import { MaterialModule } from '../material/material.module';

@NgModule({
  declarations: [StatusBannerComponent],
  imports: [CommonModule, MaterialModule],
  exports: [StatusBannerComponent]
})
export class StatusBannerModule {}
